import {
  AuthAPIApi,
  Middleware,
  RequestContext,
  ResponseContext,
  ServerConfiguration,
  createConfiguration,
} from '@demand-iq/auth-sdk';
import { loginRoute, profileChangePassword } from 'routes/routes';
import { loginRedirectUrl } from './loginRedirect';

class NoAuthCheck implements Middleware {
  pre(context: RequestContext): Promise<RequestContext> {
    return Promise.resolve(context);
  }

  post(context: ResponseContext): Promise<ResponseContext> {
    if (
      context.httpStatusCode === 401 &&
      window.location.pathname !== loginRoute &&
      window.location.pathname !== profileChangePassword
    ) {
      const featureHighlightKeys = Object.keys(localStorage).filter((key) => key.startsWith('feature_highlight-'));
      const theme = localStorage.getItem('theme');
      localStorage.clear();

      featureHighlightKeys.forEach((key) => {
        localStorage.setItem(key, 'true');
      });
      if (theme) {
        localStorage.setItem('theme', theme);
      }
      window.location.href = loginRedirectUrl(window.location.pathname, window.location.search);
    }
    return Promise.resolve(context);
  }
}
const url = import.meta.env.VITE_AUTH_URL;

const variable = {};
const server = new ServerConfiguration(url ?? 'http://localhost', variable);

// Convert to actual configuration
const config = createConfiguration({
  baseServer: server,
  promiseMiddleware: [new NoAuthCheck()],
});

const AuthApi = new AuthAPIApi(config);
export default AuthApi;
